
import GwContentTemplate from '~/patterns/templates/content';
import getKnowledgeCategories from '~/graphql/queries/getKnowledgeCategories.graphql';
import getKnowledgePages from '~/graphql/queries/getKnowledgePages.graphql';
import getKnowledgeOverviewPage from '~/graphql/queries/getKnowledgeOverviewPage.graphql';
import seo from '~/mixins/seo';
import GwPageContainer from '~/patterns/molecules/page-container/page-container';
import ImageSingle from '~/patterns/atoms/image-single/image-single';
import GwLoader from '~/patterns/atoms/loader/loader.vue';
import GwCard from '~/patterns/atoms/card/card.vue';
import GwCardGrid from '~/patterns/molecules/card-grid/card-grid.vue';
import GwPagination from '~/patterns/molecules/pagination/pagination.vue';
import GwPageTitle from '~/patterns/molecules/page-title/page-title';
import GwPageIntro from '~/patterns/molecules/page-intro/page-intro';
import GwKnowledgeFilters from '~/patterns/organisms/knowledge-filters/knowledge-filters';
import GwKnowledgeSearch from '~/patterns/organisms/knowledge-search/knowledge-search';

export default {
    components: {
        GwContentTemplate,
        GwPageContainer,
        GwCard,
        GwCardGrid,
        GwPagination,
        GwPageTitle,
        GwPageIntro,
        GwLoader,
        ImageSingle,
        GwKnowledgeFilters,
        GwKnowledgeSearch
    },
    mixins: [seo],
    layout: 'overview',
    data() {
        return {
            entry: null,
            notFound: false,
            knowledgePages: [],
            page: 1,
            pageSize: 12,
            totalCount: 200,
            filters: [],
            activeFilter: null,
            searchQuery: '',
            pending: false
        };
    },
    async fetch() {
        const site = this.$config.appMultisiteHandle,
            uri = this.$route.path.replace(/^\/|\/$/, ''),
            { data } = await this.$gql.executeQuery(
                getKnowledgeOverviewPage,
                { site, uri }
            );
        if (data && data.entry) {
            this.entry = data.entry;
        } else {
            this.notFound = true;
            if (process.server) {
                this.$nuxt.context.res.statusCode = 404;
            }
        }

        const filters = await this.$gql.executeQuery(getKnowledgeCategories, { site });

        if (filters.data && filters.data.categories) {
            this.filters = filters.data.categories;
        }

        const knowledgePages = await this.$gql.executeQuery(
            getKnowledgePages,
            {
                site,
                limit: this.pageSize,
                offset: 0,
                filterCategory: this.activeFilter,
                search: this.searchQuery
            }
        );

        this.knowledgePages.push(...knowledgePages.data.entries);
        this.totalCount = knowledgePages.data.entryCount;
    },
    watch: {
        activeFilter: {
            handler() {
                this.page = 0;
                this.knowledgePages = [];
                this.getMoreResults();
            },
            immediate: false
        },
        searchQuery: {
            handler() {
                if (this.pending) {
                    return;
                }

                this.page = 0;
                this.knowledgePages = [];
                this.getMoreResults();
            }
        }
    },
    methods: {
        async getMoreResults() {
            this.pending = true;

            const offset = this.page * this.pageSize;
            const site = this.$config.appMultisiteHandle;

            const { data } = await this.$gql.executeQuery(
                getKnowledgePages,
                {
                    site,
                    limit: this.pageSize,
                    offset,
                    filterCategory: this.activeFilter,
                    search: this.searchQuery
                }
            );

            this.totalCount = data.entryCount;

            if (data.entries && data.entries?.length) {
                this.knowledgePages.push(...data.entries);
                this.page++;
                this.pending = false;
            } else {
                this.pending = false;
            }
        }
    },
    nuxtI18n: {
        paths: {
            en: '/knowledge',
            in: '/knowledge',
            nl: '/knowledge',
            fr: '/articles',
            de: '/knowledge',
            'en-Highberg': '/knowledge',
            'nl-Highberg': '/knowledge',
            'de-Highberg': '/knowledge',
        }
    }
};
